import { css } from 'styled-components'

export const focusStyle = css`
  outline: 2px solid var(--palette-neutral-surface-light-foreground);
  outline-offset: 2px;
`

export const focusStyleOffset = '4px'

export default focusStyle
